require("./locationDetailsInventory.less");
import {LoDashStatic} from "lodash";

const _ = <LoDashStatic> require('lodash');

class LocationDetailsInventoryController {
    inventory;
    stockUpdateFunc;

    toolbarheaderDefinition = {
        isTable: true,
        previousStateArrowActive: true,
        toolbarHeading: "",
    };

    tableDefinition = {
        settings: {
            promise: null,
            hideToolbar: true,
            hidePaginator: true,
            editFunction: (ev, row) => this.editFifo(ev, row)
        },
        columns: [
            {title: 'Varenummer', name: 'itemId', noOrderBy: true},
            {title: 'Varenavn', name: 'itemName', noOrderBy: true},
            {title: 'Eldste dato', name: 'oldestDate', type: 'date', dateFormat: 'dd.MM.yyyy', noOrderBy: true},
            {title: 'Antall', name: 'quantity', type: 'number', noOrderBy: true}
        ]
    };

    constructor(private toastService,
                private Locations,
                private $stateParams,
                private $mdDialog) {
    }

    $onInit() {
        this.getLocationInventory();
    }

    getLocationInventory() {
        this.tableDefinition.settings.promise = this.Locations.getLocationBalance({locationId: this.$stateParams.locationId}).$promise.then((results) => {
            this.inventory = results;
            this.stockUpdateFunc(_.sumBy(this.inventory, "quantity"));
        }, (error) => {
            this.toastService.parseError(error);
        });
    }

    editFifo(ev, item) {
        this.$mdDialog.show({
            template: '<wms-fifo-dialog item="c.item"></wms-fifo-dialog>',
            targetEvent: ev,
            clickOutsideToClose: false,
            controllerAs: 'c',
            controller: <any>[function () {
                this.item = item;
            }],
        }).then(() => {
            this.getLocationInventory();
        });
    };
}

class LocationDetailsInventoryOptions implements ng.IComponentOptions {
    controllerAs = 'c';
    public controller: string = "rkcLocationDetailsInventoryController";
    public template: any = require('./locationDetailsInventory.html');
    bindings: any = {
        stockUpdateFunc: '='
    };
}

rkcApp.controller("rkcLocationDetailsInventoryController",
    ['toastService', 'Locations', '$stateParams', '$mdDialog',
        function (toastService, Locations, $stateParams, $mdDialog) {
            return new LocationDetailsInventoryController(toastService, Locations, $stateParams, $mdDialog);
        }])
    .component("rkcLocationDetailsInventory", new LocationDetailsInventoryOptions());


/** WEBPACK FOOTER **
 ** ./src/app/components/main/views/locations/locationDetails/locationDetailsInventory/locationDetailsInventory.ts
 **/